var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeShapePrice = function SvgBadgeShapePrice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 98 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M95.59 35.827c0 .377.377.754.377 1.509.378 1.131.756 2.64.756 4.148 3.778 21.874-.378 47.141-18.514 71.655-12.09 16.593-27.959 30.17-46.094 40.352-3.778 1.886-5.667 2.64-8.312 4.149l-2.645 1.349v-35.668l.756-.377c10.201-6.788 19.647-14.331 26.825-23.382h-.378C21.536 99.185 0 76.934 0 49.781 0 22.25 21.914 0 48.74 0c21.913 0 40.804 14.708 46.85 35.827Z"
  })));
};
export default SvgBadgeShapePrice;